export type SpacingSize = "sm" | "md" | "lg";

export const getPaddingBySpacingSize = (spacingSize: SpacingSize) => {
  switch (spacingSize) {
    case "lg":
      return 4;
    case "md":
      return 3;
    case "sm":
      return 2;
    default:
      return 3;
  }
};
